import { render, staticRenderFns } from "./singleConvertConfirmSpot.popup-chunk.vue?vue&type=template&id=2245ff4a"
import script from "./singleConvertConfirmSpot.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./singleConvertConfirmSpot.popup-chunk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports